/* src/app/components/error/error.component.css */
.error-div-left {
  padding-right: 40px;
}
.error-div-right {
  text-align: center;
}
.error-div {
  margin-top: 30px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  padding: 40px 30px 140px;
}
.error-icon {
  font-size: 14vw;
  color: #0071bb;
}
.error-desc-div {
  padding: 20px;
  color: #E11919;
  font-size: 14px;
  word-break: break-word;
}
.error-heading {
  font-size: 42px;
  color: #0071bb;
  margin-bottom: 20px;
}
.error-text {
  font-size: 16px;
  color: #0071bb;
}
/*# sourceMappingURL=error.component.css.map */
